var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "action-checklist" },
    [
      _vm.checking
        ? _c("Loading", { attrs: { text: "Sicherheitsprüfung..." } })
        : [
            _c("div", { staticClass: "tag-sections mt-4" }, [
              _vm.withMyData
                ? _c(
                    "section",
                    [
                      _c("h2", [_vm._v("Meine Daten")]),
                      _vm._v(" "),
                      _c("CustomerData", { on: { change: _vm.loadAuth } })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "section",
                [
                  _vm.withSecurityTitle
                    ? _c("h2", [_vm._v("Sicherheit")])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("Item", {
                    attrs: {
                      type: _vm.phone
                        ? "Telefonnummer (" + _vm.phone.formatted + ")"
                        : "Telefonnummer",
                      status: _vm.security.mobilePhoneConfirmed
                        ? "done"
                        : "open",
                      "confirmation-date": _vm.security.mobilePhoneDate
                    },
                    on: {
                      confirmNow: function($event) {
                        _vm.confirmNow = "mobilePhone"
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("Item", {
                    staticClass: "mt-2",
                    attrs: {
                      type: _vm.email
                        ? "E-Mail Adresse (" + _vm.email + ")"
                        : "E-Mail Adresse",
                      status: _vm.security.emailConfirmed ? "done" : "open",
                      "confirmation-date": _vm.security.emailDate
                    },
                    on: {
                      confirmNow: function($event) {
                        _vm.confirmNow = "email"
                      }
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "section",
                [
                  _c("h2", [_vm._v("Passwort ändern")]),
                  _vm._v(" "),
                  _c("ChangePassword")
                ],
                1
              )
            ])
          ],
      _vm._v(" "),
      _vm.confirmNowIdentification
        ? _c("UploadPopUp", {
            attrs: { meta: _vm.meta },
            on: {
              ok: _vm.onIdentificationChange,
              asyncFinish: _vm.onIdentificationChange,
              hidden: function($event) {
                _vm.confirmNow = undefined
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.confirmNowEmailOrMobilePhone
        ? _c("ResendPopUp", {
            attrs: {
              type: _vm.confirmNow,
              "resend-function": _vm.resendResendFunction,
              "change-function": _vm.resendChangeFunction,
              phone: _vm.phone
            },
            on: {
              success: _vm.onConfirmEmailOrMobilePhoneSuccess,
              hidden: function($event) {
                _vm.confirmNow = undefined
              }
            }
          })
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }